import { getFlag } from 'config/flags';

const SUPPORTED_COUNTRIES = [ 'US' ];
export const getAuth = state => state.auth;
export const getWgToken = state => getAuth(state).token;
export const getIsAuthenticated = state => Boolean(getAuth(state).isAuthenticated);
export const getIsWhitelisted = state => Boolean(getAuth(state).isWhitelisted);
export const getIsAuthorized = state => getIsAuthenticated(state) && getIsWhitelisted(state);
export const getHasLoginError = state => getAuth(state).hasLoginError;
export const isUserInSupportedRegion = state => {
  const { country } = getAuth(state);

  // dev and local have null as their country because this is provided b
  if (getFlag('env') !== 'prod' && country === null) {
    return true;
  }

  return SUPPORTED_COUNTRIES.includes(country);
};



// WEBPACK FOOTER //
// ./src/selectors/auth.js